import { useState } from "react";
import BusinessCommonQuestion from "@/components/business/CommonQuestion";
import BusinessComparison from "@/components/business/Comparison";
import BusinessEngagements from "@/components/business/Engagements";
import BusinessFaqs from "@/components/business/Faqs";
import BusinessForm from "@/components/business/Form";
import BusinessHero from "@/components/business/Hero";
import BusinessLayers from "@/components/business/Layers";
import BusinessProcess from "@/components/business/Process";
import BusinessStages from "@/components/business/Stages";
import BusinessTrustedAtScale from "@/components/business/TrustedAtScale";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import Navbar from "@/components/homepage/Navbar";
import InviteSection from "@/components/homepage/InviteSection";
import { FORM_CONFIGS } from "@/config/forms";

const BusinessPage = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <BusinessHero />
      <BusinessComparison />
      <BusinessLayers />
      <BusinessCommonQuestion />
      <BusinessStages />
      <InviteSection />
      <BusinessEngagements />
      <BusinessTrustedAtScale />
      <BusinessForm />
      <BusinessProcess />
      <BusinessFaqs />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="all-resources-hero"
        ctaSectionId="resource-cta"
        marketingBasePath="/business"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
        formConfig={FORM_CONFIGS.b2b}
      />
    </main>
  );
};

export default BusinessPage;
